import * as Yup from 'yup';
import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Card,
  Grid,
  Stack,
  TextField,
  IconButton,
  MenuItem,
  FormControl,
  Select,
  InputAdornment,
  InputLabel,
  CardHeader
} from '@mui/material';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { axios } from 'utils/axios';
import { FormHelperText } from '@mui/material';
import { Typography } from '@mui/material';
import { SitesIcons } from 'utils/Icons/icons';
import InfoCard from 'components/common/InfoCard';
// import axios from '.../../../utils/axios';

// Validation Schema
const NewSiteSchema = Yup.object().shape({
  Name: Yup.string().required('Site Name is required'),
  ContactName: Yup.string().required('Contact Name is required'),
  Telephone: Yup.string().required('Telephone is required'),
  Email: Yup.string().email('Invalid Email').required('Email is required'),
  ExternalRef: Yup.string().required('Externalref is required'),
  ClientId: Yup.number().required('Client id is required'),
  Postcode: Yup.string().required('Postcode is required'),
  CouncilArea: Yup.string().required('Council Area is required'),
  Notes: Yup.string().max(3000, 'Maximum 3000 characters allowed'),
  SiteStatus: Yup.string().required('Site Status is required'),
  SiteDescription: Yup.string().max(100, 'Maximum 100 characters allowed'),
  add_city: Yup.string().required('City is required'),
  add_number: Yup.string().required('City is required'),
  add_state: Yup.string().required('State is required'),
  add_line1: Yup.string().required('Address is required'),
  add_postcode: Yup.string(),
  add_country: Yup.string().required('Country is required')
});

type ContactSiteNewFormProps = {
  isEdit: boolean;
  currentSite?: any;
  isDetails?: boolean;
};
export default function SiteNewForm({ isEdit, currentSite, isDetails }: ContactSiteNewFormProps) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [councils, setCouncils] = useState([]);
  const [contacts, setContacts] = useState<{ value: string; id: number }[]>([]);
  console.log('cpntacts', contacts);

  const { clientId = '' } = useParams();
  console.log(currentSite, 'THis is the is Edit');
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: currentSite?.Name || '',
      ContactName: currentSite?.ContactName || '',
      Telephone: currentSite?.Telephone || '',
      Email: currentSite?.Email || '',
      Postcode: currentSite?.Postcode || '',
      add_line1: currentSite?.add_line1 || '',
      add_line2: currentSite?.add_line2 || '',
      ExternalRef: currentSite?.ExternalRef || '',
      add_number: currentSite?.add_number || '',
      ClientId:
        !isEdit && !isDetails && !clientId
          ? contacts.length === 1
            ? contacts[0]?.id
            : ''
          : currentSite?.ClientId,
      CouncilArea: currentSite?.CouncilArea || '',
      Notes: currentSite?.Notes || '',
      SiteStatus: currentSite?.SiteStatus || '',
      SiteDescription: currentSite?.SiteDescription || '',
      add_city: currentSite?.add_city || '',
      add_state: currentSite?.add_state || '',
      add_postcode: currentSite?.PostCode || '',
      add_country: currentSite?.add_country || ''
    },
    validationSchema: isDetails ? null : NewSiteSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        if (!isDetails) {
          if (!isEdit) {
            await axios.post('/rest/api/contacts/sites', {
              ...values,
              add_postcode: values.Postcode
            });
          } else {
            await axios.put(`/rest/api/contacts/sites/${currentSite.Id}`, {
              ...values,
              add_postcode: values.Postcode
            });
          }

          enqueueSnackbar(!isEdit ? 'Create success' : 'Update success', { variant: 'success' });
          if (!clientId) {
            navigate('/dashboard/sites/list');
          }
        } else {
          navigate(
            `/dashboard/contacts/details/${
              !isEdit && !isDetails ? Number(clientId) : currentSite?.ClientId
            }`
          ); // Fixed here by adding the missing closing parenthesis
        }
      } catch (error) {
        console.error(error);
        setSubmitting(false);
      }
    }
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  const fetchAllCouncils = async () => {
    const response = await axios.get('/rest/api/council/area');
    const allCouncils = response.data.data.data || [];

    setCouncils(allCouncils?.map((el: any) => ({ value: el.CouncilArea, id: el.Id })));
  };
  console.log('clientId', clientId);
  const fetchContacts = async () => {
    try {
      const response = await axios.get('/rest/api/contacts/info');
      const allContacts = response.data.data.data || [];
      console.log('allContacts', allContacts);

      if (!clientId) {
        // If no clientId is provided, list all contacts
        setContacts(allContacts.map((el: any) => ({ value: el.ContactName, id: el.Id })));
        return;
      }

      // Filter contacts by clientId
      const filteredContacts = allContacts
        .filter((el: any) => el.Id === Number(clientId))
        .map((el: any) => ({ value: el.ContactName, id: el.Id }));

      // Set filtered contacts
      setContacts(filteredContacts);
      if (filteredContacts.length === 1) {
        // If one contact matches, set it as the default value
        formik.setFieldValue('ContactName', filteredContacts[0].value);
      }
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  };

  useEffect(() => {
    fetchAllCouncils();
    fetchContacts();
  }, []);
  return (
    <>
      {isDetails ? (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              {/* Site Information */}
              <CardHeader title="Site Information" />
              <Stack spacing={3} padding={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <InfoCard
                      icon={SitesIcons.work}
                      title="Site Name"
                      content={formik.values.Name}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InfoCard
                      icon={SitesIcons.phone}
                      title="Telephone"
                      content={formik.values.Telephone}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InfoCard icon={SitesIcons.email} title="Email" content={formik.values.Email} />
                  </Grid>
                </Grid>
              </Stack>

              {/* Address Details */}
              <CardHeader title="Address Details" />
              <Stack spacing={3} padding={3}>
                <Grid container spacing={2}>
                  {[
                    {
                      title: 'House Number',
                      value: formik.values.add_number,
                      icon: SitesIcons.home
                    },
                    {
                      title: 'Address Line 1',
                      value: formik.values.add_line1,
                      icon: SitesIcons.home
                    },
                    {
                      title: 'Address Line 2',
                      value: formik.values.add_line2,
                      icon: SitesIcons.home
                    },
                    { title: 'City', value: formik.values.add_city, icon: SitesIcons.place },
                    { title: 'State', value: formik.values.add_state, icon: SitesIcons.place },
                    { title: 'Country', value: formik.values.add_country, icon: SitesIcons.public },
                    { title: 'Postcode', value: formik.values.Postcode, icon: SitesIcons.place }
                  ].map(({ title, value, icon }, index) => (
                    <Grid key={index} item xs={12} sm={6}>
                      <InfoCard icon={icon} title={title} content={value} />
                    </Grid>
                  ))}
                </Grid>
              </Stack>

              {/* Council and Client Details */}
              <CardHeader title="Council and Client Details" />
              <Stack spacing={3} padding={3}>
                <Grid container spacing={2}>
                  {[
                    {
                      title: 'Council Area',
                      value: formik.values.CouncilArea,
                      icon: SitesIcons.place
                    },
                    {
                      title: 'Contact Name',
                      value: formik.values.ContactName,
                      icon: SitesIcons.phone
                    },
                    {
                      title: 'External Ref',
                      value: formik.values.ExternalRef,
                      icon: SitesIcons.noteAlt
                    }
                  ].map(({ title, value, icon }, index) => (
                    <Grid key={index} item xs={12} sm={6}>
                      <InfoCard icon={icon} title={title} content={value} />
                    </Grid>
                  ))}
                </Grid>
              </Stack>

              {/* Additional Details */}
              <CardHeader title="Additional Details" />
              <Stack spacing={3} padding={3}>
                <Grid container spacing={2}>
                  {[
                    {
                      title: 'Site Status',
                      value: formik.values.SiteStatus,
                      icon: SitesIcons.work
                    },
                    {
                      title: 'Site Description',
                      value: formik.values.SiteDescription,
                      icon: SitesIcons.description
                    },
                    {
                      title: 'Notes',
                      value: formik.values.Notes,
                      icon: SitesIcons.noteAlt,
                      fullWidth: true
                    }
                  ].map(({ title, value, icon, fullWidth }, index) => (
                    <Grid key={index} item xs={12} sm={fullWidth ? 12 : 6}>
                      <InfoCard icon={icon} title={title} content={value} />
                    </Grid>
                  ))}
                </Grid>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Card sx={{ p: 3 }}>
                  <Stack spacing={3}>
                    {/* Site Information */}
                    <Typography variant="h6" gutterBottom>
                      Site Information
                    </Typography>
                    <TextField
                      fullWidth
                      label="Site Name"
                      {...getFieldProps('Name')}
                      error={Boolean(touched.Name && errors.Name)}
                      helperText={touched.Name && errors.Name}
                    />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <TextField
                        fullWidth
                        label="Telephone"
                        {...getFieldProps('Telephone')}
                        error={Boolean(touched.Telephone && errors.Telephone)}
                        helperText={touched.Telephone && errors.Telephone}
                      />
                      <TextField
                        fullWidth
                        label="Email"
                        {...getFieldProps('Email')}
                        error={Boolean(touched.Email && errors.Email)}
                        helperText={touched.Email && errors.Email}
                      />
                    </Stack>

                    {/* Address Details */}
                    <Typography variant="h6" gutterBottom>
                      Address Details
                    </Typography>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        label="House Number*"
                        InputLabelProps={{ shrink: true }}
                        {...getFieldProps('add_number')}
                        error={Boolean(touched.add_number && errors.add_number)}
                        helperText={touched.add_number && errors.add_number}
                      />
                      <TextField
                        label="Address Line 1*"
                        {...getFieldProps('add_line1')}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(touched.add_line1 && errors.add_line1)}
                        helperText={touched.add_line1 && errors.add_line1}
                      />
                      <TextField
                        label="Address Line 2*"
                        {...getFieldProps('add_line2')}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(touched.add_line2 && errors.add_line2)}
                        helperText={touched.add_line2 && errors.add_line2}
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <TextField
                        fullWidth
                        label="Postcode"
                        {...getFieldProps('Postcode')}
                        error={Boolean(touched.Postcode && errors.Postcode)}
                        helperText={touched.Postcode && errors.Postcode}
                      />
                    </Stack>
                    {/* Council and Client Details */}
                    <Typography variant="h6" gutterBottom>
                      Council and Client Details
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.CouncilArea && errors.CouncilArea)}
                      >
                        <InputLabel>Council Area</InputLabel>
                        <Select
                          {...getFieldProps('CouncilArea')}
                          defaultValue=""
                          label="Council Area"
                        >
                          {councils.map((option: any) => (
                            <MenuItem key={option.id} value={option.value}>
                              {option.value}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{touched.CouncilArea && errors.CouncilArea}</FormHelperText>
                      </FormControl>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.ContactName && errors.ContactName)}
                      >
                        <InputLabel>Contact Name</InputLabel>
                        <Select
                          {...getFieldProps('ContactName')}
                          defaultValue=""
                          onChange={(e) => {
                            const selectedContact = contacts.find(
                              (contact) => contact.value === e.target.value
                            );
                            // Update ClientId based on the selected contact
                            formik.setFieldValue('ContactName', e.target.value);
                            formik.setFieldValue(
                              'ClientId',
                              selectedContact ? selectedContact.id : ''
                            );
                          }}
                          disabled={Boolean(clientId && contacts.length === 1)}
                          label="Contact Name"
                        >
                          {contacts.map((option: any) => (
                            <MenuItem key={option.id} value={option.value}>
                              {option.value}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{touched.ContactName && errors.ContactName}</FormHelperText>
                      </FormControl>
                      <TextField
                        fullWidth
                        label="External Ref"
                        {...getFieldProps('ExternalRef')}
                        error={Boolean(touched.ExternalRef && errors.ExternalRef)}
                        helperText={touched.ExternalRef && errors.ExternalRef}
                      />
                    </Stack>

                    {/* Other Details */}
                    <Typography variant="h6" gutterBottom>
                      Additional Details
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        displayEmpty
                        {...getFieldProps('SiteStatus')}
                        error={Boolean(touched.SiteStatus && errors.SiteStatus)}
                      >
                        <MenuItem value="">Select Site Status</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      fullWidth
                      label="Site Description"
                      multiline
                      rows={4}
                      {...getFieldProps('SiteDescription')}
                      error={Boolean(touched.SiteDescription && errors.SiteDescription)}
                      helperText={touched.SiteDescription && errors.SiteDescription}
                    />
                    <TextField
                      fullWidth
                      label="Notes"
                      multiline
                      rows={4}
                      {...getFieldProps('Notes')}
                      error={Boolean(touched.Notes && errors.Notes)}
                      helperText={touched.Notes && errors.Notes}
                    />

                    {/* Submit Button */}
                    {!isDetails && (
                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                          {isEdit ? 'Save Changes' : 'Create Site'}
                        </LoadingButton>
                      </Box>
                    )}
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      )}
    </>
  );
}
